import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Mail, MailCheck, ArrowLeft } from 'lucide-react';
import AuthShell from '../../components/auth/AuthShell';
import { AuthHeading, AuthField, AuthInput, ErrorBanner, PrimaryButton } from '../../components/auth/AuthPrimitives';
import api from '../../utils/axios';

export default function ForgotPasswordPage() {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [fieldError, setFieldError] = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  async function handleSubmit(e) {
    e.preventDefault();
    if (!email) return setFieldError('Enter your email');
    if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)) return setFieldError('Use a valid email address');
    setFieldError('');
    setLoading(true);
    try {
      await api.post('/accounts/auth/password/reset/', { email });
    } catch {
      // Always show sent state — backend does the same to prevent account enumeration
    } finally {
      setLoading(false);
      setSent(true);
    }
  }

  if (sent) {
    return (
      <AuthShell onLogoClick={() => navigate('/login')}>
        <div style={{ textAlign: 'center' }}>
          <div style={{ width: 56, height: 56, border: '1px solid #000', borderRadius: 999, margin: '0 auto 24px', display: 'inline-flex', alignItems: 'center', justifyContent: 'center' }}>
            <MailCheck size={24} />
          </div>
          <AuthHeading align="center" title="Check your inbox" subtitle={<>We sent a password reset link to <strong style={{ color: '#000' }}>{email}</strong>. The link expires in 30 minutes.</>} />
          <div style={{ marginTop: 24, fontSize: 13, color: '#64748B', lineHeight: 1.6 }}>
            Didn&rsquo;t receive it? Check your spam folder, or{' '}
            <a onClick={() => setSent(false)} style={{ color: '#000', textDecoration: 'underline', cursor: 'pointer' }}>try a different email</a>.
          </div>
          <div style={{ marginTop: 32 }}>
            <PrimaryButton onClick={() => navigate('/login')} icon={ArrowLeft}>Back to Sign In</PrimaryButton>
          </div>
        </div>
      </AuthShell>
    );
  }

  return (
    <AuthShell onLogoClick={() => navigate('/login')}>
      <form onSubmit={handleSubmit} noValidate>
        <AuthHeading title="Reset your password" subtitle="Enter the email tied to your Meduri account. We'll send you a link to set a new password." />
        <AuthField label="Work email" htmlFor="fp-email" error={fieldError}>
          <AuthInput id="fp-email" type="email" autoComplete="email" placeholder="you@clinic.com" leadingIcon={Mail} value={email} onChange={e => { setEmail(e.target.value); setFieldError(''); }} error={fieldError} />
        </AuthField>
        <div style={{ marginTop: 20 }}>
          <PrimaryButton type="submit" loading={loading}>Send Reset Link</PrimaryButton>
        </div>
        <div style={{ marginTop: 20, fontSize: 14, color: '#1D2433', textAlign: 'center' }}>
          <a onClick={() => navigate('/login')} style={{ color: '#000', textDecoration: 'underline', cursor: 'pointer' }}>Back to sign in</a>
        </div>
      </form>
    </AuthShell>
  );
}
